import { ChakraV3, ScrollArea } from '@piccolohealth/ui';
import React from 'react';
import { useScrollRestoration } from '../../../hooks/useScrollRestoration';

interface Props {
  documentId: string;
}

export const ConnectedContent = (props: React.PropsWithChildren<Props>) => {
  const { children, documentId } = props;

  const { opacity, ref } = useScrollRestoration(documentId);

  return (
    <ScrollArea scrollRef={ref} opacity={opacity}>
      <ChakraV3.Box display='grid' flexDir='column' h='full' w='full'>
        <ChakraV3.Flex>{children}</ChakraV3.Flex>
      </ChakraV3.Box>
    </ScrollArea>
  );
};
